import type { PublicShipmentStatus } from "./types";

function getStateAuthorName(author: UserRoleInfo) {
  return `${author.user.first_name} ${author.user.last_name}`;
}

export function buildPublicShipmentStatusListFromShipmentLifecycle(
  shipment: PublicShipment,
): PublicShipmentStatus[] {
  const statuses: PublicShipmentStatus[] = [];

  if (shipment.first_pickup) {
    statuses.push({
      notes: shipment.first_pickup.notes ?? "",
      createdAt: shipment.first_pickup.created_at,
      timestamp: shipment.first_pickup.picked_up_at,
      routePointNumber: 1,
      createdBy: getStateAuthorName(shipment.first_pickup.created_by),
      type: "Shipment Picked Up",
    });
  }

  if (shipment.delivery) {
    const destinationPoint =
      shipment.route_points[shipment.route_points.length - 1];
    statuses.push({
      notes: shipment.delivery.notes ?? "",
      createdAt: shipment.delivery.created_at,
      timestamp: shipment.delivery.delivered_at,
      routePointNumber: destinationPoint?.point_number ?? null,
      createdBy: getStateAuthorName(shipment.delivery.created_by),
      type: "Shipment Delivered",
    });
  }

  return statuses;
}

export function buildPublicShipmentStatusListFromETAs(
  etas: RoutePointETA[],
): PublicShipmentStatus[] {
  return etas.map((eta) => ({
    notes: eta.notes ?? "",
    createdAt: eta.created_at,
    timestamp: eta.eta,
    routePointNumber: eta.point.point_number,
    createdBy: getStateAuthorName(eta.created_by),
    type: "ETA Added",
  }));
}
